export const CHANNEL_ID = 'channelId';
export const ID = 'id';
export const INSTANCE_DELIVERY_IDENTIFIER = 'instanceDeliveryIdentifier';
export const IS_ACTIVE = 'isActive';
export const IS_AUTHORIZED = 'isAuthorized';
export const NAME = 'name';